export enum FilterOperators {
    None = -1,
    Equals = 0,
    NotEquals = 1,
    GreaterThan = 2,
    GreaterOrEqualThan = 3,
    LessThan = 4,
    LessOrEqualThan = 5,
    IsNull = 6,
    IsNotNull = 7,
    Contains = 8,
    StartsWith = 9,
    EndsWith = 10,
    Between = 11,
    In = 12
}